(() => {
  let lastUrlParams =
    new URLSearchParams(window.location.search).get("page") ?? "1";
  let listenersInitialized = false;

  const handleSwatchClick = (button, container) => {
    const variantId = button.getAttribute("data-variant-id");
    if (variantId && container) {
      container.setAttribute("data-variant-id", variantId);
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent("abra:render"));
      }, 500);
    }
  };

  const handleProductSwatchClick = (button) => {
    const activeLensActiveStepContainer = document.querySelector(
      ".product__lens-selection-step.active"
    );
    const variantId = button.getAttribute("data-variant-id");
    
    if (variantId && activeLensActiveStepContainer) {
      activeLensActiveStepContainer.setAttribute("data-variant-id", variantId);
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent("abra:render"));
      }, 500);
    }
  };

  const addSwatchButtonListeners = () => {
    if (listenersInitialized) return;
    listenersInitialized = true;

    const swatchButtons = document.querySelectorAll(".collection__item-swatch:not([data-abra-listener])");
    swatchButtons.forEach((button) => {
      const container = button.closest(".collection__item");
      if (container) {
        button.setAttribute("data-abra-listener", "true");
        button.addEventListener("click", () => handleSwatchClick(button, container), { once: false });
      }
    });

    const productButtonSwatches = document.querySelectorAll(".product__swatch:not([data-abra-listener])");
    productButtonSwatches.forEach((button) => {
      const activeLensActiveStepContainer = document.querySelector(
        ".product__lens-selection-step.active"
      );
      
      if (activeLensActiveStepContainer) {
        button.setAttribute("data-abra-listener", "true");
        button.addEventListener("click", () => handleProductSwatchClick(button), { once: false });
        
        if (button.classList.contains("active")) {
          const variantId = button.getAttribute("data-variant-id");
          if (variantId) {
            activeLensActiveStepContainer.setAttribute("data-variant-id", variantId);
          }
        }
      }
    });
  };

  const initialize = () => {
    const currentUrlParams =
      new URLSearchParams(window.location.search).get("page") ?? "1";

    if (currentUrlParams !== lastUrlParams) {
      lastUrlParams = currentUrlParams;
      listenersInitialized = false;
      setTimeout(addSwatchButtonListeners, 2000);
    }
  };

  if (document.readyState === "loading") {
    window.addEventListener("DOMContentLoaded", () => {
      setTimeout(addSwatchButtonListeners, 2000);
    });
  } else {
    setTimeout(addSwatchButtonListeners, 2000);
  }

  window.addEventListener("popstate", initialize);
  window.addEventListener("pushState", initialize);
  window.addEventListener("replaceState", initialize);

  const originalPushState = history.pushState;
  history.pushState = function (...args) {
    originalPushState.apply(this, args);
    window.dispatchEvent(new Event("pushState"));
  };

  const originalReplaceState = history.replaceState;
  history.replaceState = function (...args) {
    originalReplaceState.apply(this, args);
    window.dispatchEvent(new Event("replaceState"));
  };
})();

// race condition fix
(() => {
  const originalFetch = window.fetch;
  let isProcessingLensSelection = false;

  window.fetch = function(...args) {
    const [url, options] = args;

    if (url === '/cart/add.js' && options && options.body) {
      const button = document.querySelector('[data-lens-selection-atc]');
      
      if (button && !isProcessingLensSelection) {
        isProcessingLensSelection = true;

        return originalFetch.apply(this, args)
          .then(async (response) => {
            const clonedResponse = response.clone();
            
            try {
              const data = await clonedResponse.json();
              
              if (!data.status && !data.description) {
                await new Promise(resolve => setTimeout(resolve, 1500));
              }
            } catch (error) {}

            isProcessingLensSelection = false;
            return response;
          })
          .catch((error) => {
            isProcessingLensSelection = false;
            throw error;
          });
      }
    }

    return originalFetch.apply(this, args);
  };
})();




